export const Types = {
  GET_REQUEST: 'faq/GET_REQUEST',
  GET_SUCCESS: 'faq/GET_SUCCESS',
};

const INITIAL_STATE = {
  faq: 'Carregando...',
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { faq: action.payload.data, loading: false, error: null };
    default:
      return state;
  }
};

export const Creators = {
  getFaqRequest: () => ({ type: Types.GET_REQUEST }),
  getFaqSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/faq.js